import { useEditor } from '@candulabs/craft';
import { nanoid } from 'nanoid';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { useFlow } from 'craft/state/flows/useFlow';

import { setFormDisplayError } from './actions';
import { createFormStep } from './createFormStep';
import { useFormState } from './selectors';

export const useForm = (nodeId?: string) => {
  const { actions, query } = useEditor();
  const dispatch = useDispatch();
  const node = query.node(nodeId)?.get();
  const { formId } = node?.data?.props || {};
  const { index, stepIds: flowStepIds, activeStepId, onAddStep, ...otherFlow } = useFlow(nodeId);

  const submittedStepId = query.node(node?.data?.nodes[node?.data?.nodes.length - 1])?.get()?.data
    ?.props?.stepId;
  const stepIds = useMemo(() => {
    return [...flowStepIds, submittedStepId];
  }, [flowStepIds, submittedStepId]);
  const formState = useFormState(formId);

  const onSetStepId = (stepId: string) => {
    actions.selectNode(nodeId);
    dispatch(otherFlow.onSetStepId(stepId, stepIds.indexOf(stepId)));
  };

  return {
    index,
    isMultistepForm: flowStepIds.length > 1,
    onAddStep: () => {
      onAddStep(createFormStep(nanoid(6)));
    },
    activeStepId,
    submittedStepId,
    formId,
    stepIds: flowStepIds,
    onSetStepId,
    isSubmitStep: index === flowStepIds.length,
    setDisplayError: (state: boolean): void => {
      dispatch(setFormDisplayError(formId, state));
    },
    shouldDisplayErrorState: formState?.displayError === true,
  };
};
